import * as styles from "./ListEmpty.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { useListContext } from "./List.context";
import type { ListEmptyProps } from "./List.types";

export function ListEmpty({
  icon,
  className,
  children,
  ...props
}: ListEmptyProps): JSX.Element {
  const { size } = useListContext();

  return (
    <div
      data-slot="list-empty"
      role="status"
      className={clsx(styles.empty({ size }), className)}
      {...props}
    >
      {undefined !== icon && <span className={styles.icon}>{icon}</span>}

      {children}
    </div>
  );
}
